import 'regenerator-runtime/runtime';
import { all, call, put, select, take } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  ImmobilieUebernehmenPayload,
  MasterProduktData,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { IAppState } from '../appState';
import { VwgActions } from '../vwgActions';

export function* watchProdukteReceivedToPreselectOeltank() {
  while (true) {
    try {
      yield all([
        call(waitForMatchingAppIdAction, GlobalActions.PRODUKT_RECEIVED),
        call(waitForMatchingAppIdAction, GlobalActions.IMMOBILIE_UEBERNEHMEN),
      ]);
      yield call(oeltankVorauswaehlen);
    } catch (err) {
      //ToDo: untersuchen
      PS20Logger.error(App.VWG_V2, 'Saga error in watchProdukteReceivedToPreselectOeltank: ' + err);
    }
  }
}

function* waitForMatchingAppIdAction(waitForActionWithType: string) {
  let done = false;
  while (!done) {
    const action: GlobalAction<MasterProduktData | ImmobilieUebernehmenPayload> =
      yield take(waitForActionWithType);
    const { angebotsId }: IAppState = yield select();
    if (action.payload.appId === App.VWG_V2 && action.payload.angebotsId === angebotsId) {
      done = true;
    }
  }
}

export function* oeltankVorauswaehlen() {
  const state: IAppState = yield select();
  if (state.vorbelegungen.oeltankVorbelegt) {
    yield put(new VwgActions().oeltankVorbelegen());
  }
}
